import { render, staticRenderFns } from "./approval-defect-vehicle.vue?vue&type=template&id=4ee985be&scoped=true&"
import script from "./approval-defect-vehicle.vue?vue&type=script&lang=js&"
export * from "./approval-defect-vehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee985be",
  null
  
)

export default component.exports